import React from "react";
import Utils from "Utils/utils";
import {
  INSTALL_PLUGIN_URL,
  INSTALL_PLUGIN_VIA_ZIP_URL,
  INSTALL_CTA_LINK
} from "Static/constant";
import { confirmationPopupState } from "Components/common/confirmationPopup";

const pluginNotInstalled = pluginUrl => {
  const ShowInstallExtension = () => {
    return (
      <div className="installExtensionWrapper">
        <div className="headingTitle">Almost there!</div>
        <div className="notification">
          Install the Salesgear LinkedIn Connector to connect your LinkedIn account.
        </div>
      </div>
    );
  };

  const installExtension = () => {
    confirmationPopupState.setPopupValues({
      content: <ShowInstallExtension />,
      actionBtnText: "Install",
      dynamicDom: true,
      callback: () => {
        // Utils.windowRedirect(pluginUrl || INSTALL_PLUGIN_URL);
        // Utils.windowRedirect(INSTALL_PLUGIN_VIA_ZIP_URL);
        Utils.windowRedirect(INSTALL_CTA_LINK);
        confirmationPopupState.setShowPopup(false);
      },
      btnClassName: "installExtension"
    });
    confirmationPopupState.setShowPopup(true);
  };

  return installExtension();
};

export { pluginNotInstalled };
export default pluginNotInstalled;
